import { defineMessages } from 'react-intl';

export default defineMessages({
  someUploads: {
    id: 'src.pages.FileUploadModal.someUploads',
    defaultMessage: "Some uploads weren't included",
  },
  filesNotUploaded: {
    id: 'src.pages.FileUploadModal.filesNotUploaded',
    defaultMessage: 'The following files were not uploaded:',
  },
  dontWorry: {
    id: 'src.pages.FileUploadModal.dontWorry',
    defaultMessage: "Don't worry, you can email these files (and more) to your Claims team member later.",
  },
  okay: {
    id: 'src.pages.FileUploadModal.okay',
    defaultMessage: 'Okay',
  },
  tooltip: {
    id: 'tooltip',
    defaultMessage: 'You can upload {videoAudioImageAndTextDocuments} to support your claim. Each file should be a maximum size of 25MB. For larger files, you can email them to your Claims team member later.',
  },
  tooltip_title: {
    id: 'Uploading files',
    defaultMessage: 'Uploading files',
  },
  videoAudioImageAndTextDocuments: {
    id: 'videoAudioImageAndTextDocuments',
    defaultMessage: 'video, audio, image and text documents',
  },
  videoAudioImageAndTextDocumentsUrl: {
    id: 'videoAudioImageAndTextDocumentsUrl',
    defaultMessage: 'https://www.sonnet.ca/faqs/claims/document-upload-file-types',
  },
  fileTypeNotAccepted: {
    id: 'fileTypeNotAccepted',
    defaultMessage: "Oops! We can't accept this file type. {learnMoreAbout}.",
  },
  learnMoreAbout: {
    id: 'learnMoreAbout',
    defaultMessage: 'Learn more about the types of files you can upload',
  },
  learnMoreAboutUrl: {
    id: 'learnMoreAboutUrl',
    defaultMessage: 'https://www.sonnet.ca/faqs/claims/document-upload-file-types',
  },
  dragAndDrop: {
    id: 'src.pages.FileUploadModal.dragAndDrop',
    defaultMessage: 'Drag and drop or upload',
  },
});
